import { http } from 'utils'
import { SET_ITEMS } from 'vx/mutations'
import firefighters from './customers/firefighters'
import products from './customers/products'
import ellipsePayrolls from './customers/ellipse-payrolls'

export default {
  namespaced: true,

  modules: {
    firefighters,
    ellipsePayrolls,
    products
  },

  state: {
    customers: []
  },

  actions: {
    async getCustomers ({ commit }, { params = {} } = {}) {
      const response = await http.get(`customers`, { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetCustomers ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.customers = items
    }
  }
}
